import { MdWork as WorkIcon, MdArrowBack } from 'react-icons/md';
import experience from '../../data/experience.json';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Experience.scss';
import '../AllProjects/AllProjects.scss';

const AllExperiences = () => {
  const data = experience;
  const [expandedJobIndex, setExpandedJobIndex] = useState(null);
  const navigate = useNavigate();
  
  const toggleDescription = (index) => {
    setExpandedJobIndex(expandedJobIndex === index ? null : index);
  };

  return (
    <div className="app__experience" style={{ padding: '4rem 2rem', minHeight: '100vh' }}>

      {/* ── Header ── */}
      <div className="ap__header" style={{ marginTop: '2rem' }}>
        <button className="ap__back-btn" onClick={() => navigate('/')}>
          <MdArrowBack />
          <span>Home</span>
        </button>
        <div className="ap__header-text">
          <h1 className="ap__title">Professional Experience</h1>
          <p className="ap__subtitle">My journey through roles, companies, and the things I built along the way</p>
        </div>
      </div>
      
      <VerticalTimeline>
        {data.map((job, index) => (
          <VerticalTimelineElement
            key={index}
            className="vertical-timeline-element--work"
            contentStyle={{ 
              background: (job.end==="present")?("var(--current-color)"):("var(--card-color)"), 
              color: "var(--primary-color)" 
            }}
            contentArrowStyle={{
              borderRight:(job.end==="present")?("7px solid var(--current-color)"):(" 7px solid var(--card-color)")}}
            date={job.start +" - "+ job.end}
            iconStyle={{ 
              background: (job.end==="present")?("var(--current-color)"):("var(--card-color)"), 
              color: "var(--primary-color)" }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">{job.role}</h3>
            <h4 className="vertical-timeline-element-subtitle">{job.company} - {job.city}</h4>
            {job.description && (
              <>
                <span 
                  onClick={() => toggleDescription(index)}
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    transition: "opacity 0.2s ease",
                    display: "inline-block",
                    color: 'var(--primary-color)', 
                    cursor: 'pointer',
                    padding: 0,
                    margin: '10px 0'
                  }}
                >
                  {expandedJobIndex === index ? 'Click to Hide Details' : 'Click to Read More...'}
                </span>
                {expandedJobIndex === index && (
                  <p style={{color: "var(--secondary-color)"}}>
                    <ul>
                      {job.description.map((desc, descIndex) => (
                        <li key={descIndex}>{desc}</li>
                      ))}
                    </ul>
                  </p>
                )}
              </>
            )}
          </VerticalTimelineElement>
        ))}        
      </VerticalTimeline>
    </div>
  );
};

export default AllExperiences;